var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tocItems.length > 0)?_c('nav',{staticClass:"section-toc"},[_c('div',{staticClass:"toc-heading"},[_vm._v("Оглавление")]),_vm._v(" "),_c('ul',{staticClass:"toc-list"},_vm._l((_vm.tocItems),function(item){return _c('toc-item',{key:item.id,attrs:{"item":item,"level":0},on:{"scroll":_vm.scrollToSection}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }